var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46346 7.26031L13.8008 4.5C13.9039 3.98252 13.508 3.5 12.9803 3.5H3.04426C2.52396 3.5 2.15092 4.00175 2.30078 4.5L7.53829 7.25696C7.82759 7.40925 8.17306 7.4105 8.46346 7.26031Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.30862C2.00028 5.93721 2.39134 5.69534 2.72363 5.86135L7.55273 8.27639C7.83426 8.41716 8.16574 8.41716 8.44727 8.27639L13.2764 5.86135C13.6087 5.69534 13.9997 5.93721 14 6.30862V11.5C14 12.0523 13.5523 12.5 13 12.5H4.5C5.3284 12.5 5.99995 11.8284 6 11C6 10.9711 5.99673 10.9426 5.99512 10.9141C6.57986 10.7093 6.99996 10.1547 7 9.50002C7 8.6716 6.32843 8.00002 5.5 8.00002H2.5C2.3245 8.00002 2.15653 8.03155 2 8.08694V6.30862Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentEmail);
export default __webpack_public_path__ + "static/media/payment-email.5862876ac75246b8352da409f8305625.svg";
export { ForwardRef as ReactComponent };